<script lang="ts">
    import Tooltip from '$saga/components/Tooltip.svelte';

    export let tooltipContent: string, tooltipLabel: string;
</script>

<Tooltip {tooltipContent} {tooltipLabel} />
